var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Datepicker'),_c('ul',_vm._l((_vm.files),function(item,i){return _c('li',{key:i},[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":item.url,"type":item.type}})]),_c('a',[_vm._v(_vm._s(item.title))])])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }